import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Create Change Impact',
      type: 'details',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.change.impact',
            },
          },
        ],
      },
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Impact ID',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '++': [
                      'CI-',
                      {
                        '+': [
                          {
                            '#': {
                              '@': 'existingChangeImpacts',
                            },
                          },
                          1,
                        ],
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'targetGoLiveDate',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Date',
                          type: 'DATE',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Change Impact Title',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: "What's Changing Summary",
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'currentState',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Current State',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'futureState',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Future State',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'workstream',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Workstream',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_workstream',
                              isMultiselect: true,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'topic',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Topic',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'degreeOfChange',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Degree of Change',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_rank',
                              isMultiselect: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'areaOfConcern',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Area of Concern',
                          type: 'BOOL',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'keyBenefit',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Key Benefit',
                          type: 'BOOL',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Type',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_type',
                              isMultiselect: true,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'anticipatedResponseOfChange',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Anticipated Response of Change',
                          type: {
                            '{}': {
                              enumId:
                                'enum::!change_impact_anticipated_response',
                              isMultiselect: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'validationStatus',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Validation Status',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_validation_status',
                              isMultiselect: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'communicationsNeeded',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Communications Needed',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_yes_no_na',
                              isMultiselect: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'communicationsNotes',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Communications Notes',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'trainingImplications',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Training Implications',
                          type: {
                            '{}': {
                              enumId: 'enum::!change_impact_yes_no_na',
                              isMultiselect: false,
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'trainingImplicationsNotes',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Training Implications Notes',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'otherComments',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Other Comments',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'save.change.impact',
                },
              },
              variables: {
                '{}': {
                  changeImpactId: '${field:code}',
                  changeImpactCode: '${field:code}',
                  changeImpactName: '${field:name}',
                  changeImpactType: '${field:type}',
                  changeImpactTopic: '${field:topic}',
                  changeImpactKeyBenefit: '${field:keyBenefit}',
                  changeImpactDescription: '${field:descr}',
                  changeImpactFutureState: '${field:futureState}',
                  changeImpactCurrentState: '${field:currentState}',
                  changeImpactAreaOfConcern: '${field:areaOfConcern}',
                  changeImpactOtherComments: '${field:otherComments}',
                  changeImpactDegreeOfChange: '${field:degreeOfChange}',
                  changeImpactWorkstream: '${field:workstream}',
                  changeImpactTargetGoLiveDate: '${field:targetGoLiveDate}',
                  changeImpactValidationStatus: '${field:validationStatus}',
                  changeImpactCommunicationsNotes:
                    '${field:communicationsNotes}',
                  changeImpactCommunicationsNeeded:
                    '${field:communicationsNeeded}',
                  changeImpactTrainingImplications:
                    '${field:trainingImplications}',
                  changeImpactTrainingImplicationsNotes:
                    '${field:trainingImplicationsNotes}',
                  changeImpactAnticipatedResponseOfChange:
                    '${field:anticipatedResponseOfChange}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    existingChangeImpacts: {
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
